export default __webpack_public_path__ + "static/210519_魔獄塔更新熱更完成公告_en-36d19fbc2e4015e6f7aa7463d5bb273b.png";